import { map } from 'rxjs';
import { convertToBehaviorSubject } from '../utils';
// inject FeatureRouterLinkResolverService instead of this class to build links.
// frontend: injected in root as FeatureRouterLinkResolverService
// backend: NOT INJECTABLE! use FeatureRouterLinkResolverService!
// pipe is declared in CoreFeatureModule
export class RouterLinkResolverService {
  constructor(registry) {
    this.registry = registry;
    this.allPlatformsResolversMap$ = this.createAllRouterLinkResolverMaps();
  }
  getRouterLinkResolvers(platform) {
    if (!IS_PRODUCTION && !['frontend', 'admin'].includes(platform)) {
      throw new Error('Unsupported RouterLinkResolver platform requested: ' + platform);
    }
    return this.allPlatformsResolversMap$.pipe(map(allResolvers => allResolvers[platform]));
  }
  getRouterLinkResolversForAllPlatforms() {
    return this.allPlatformsResolversMap$;
  }
  resolveRouterLink(platform, name, info, allowUndefined = false) {
    const resolvers = this.allPlatformsResolversMap$.getValue()?.[platform];
    if (resolvers === null) throw new Error('tried to resolve a routerLink before resolvers observable has been populated!');
    if (!resolvers.has(name)) {
      if (allowUndefined) return null;
      throw new Error("RouterLink resolver '" + platform + '::' + name + "' is not defined!");
    }
    const resolverDef = resolvers.get(name);
    const resolvedRoute = resolverDef.resolve(info || null);
    if (!Array.isArray(resolvedRoute)) return [resolvedRoute];else return resolvedRoute;
  }
  createAllRouterLinkResolverMaps() {
    const base = this.registry.getBaseRegistry().pipe(map(baseFeatures => {
      const mappedResolvers = this.generateResolversBaseMap();
      baseFeatures.forEach(feature => {
        const definition = feature.getSharedDefinitionCached();
        if (!definition.routerLinkResolvers) return;
        const platformIds = Object.keys(definition.routerLinkResolvers);
        platformIds.forEach(platform => {
          if (!IS_PRODUCTION && !['frontend', 'admin'].includes(platform)) {
            throw new Error('Unsupported RouterLinkResolver platform: ' + platform + ' found in ' + feature.resolveFeatureInfoFromStatic().context.featureId);
          }
          const resolversForPlatform = definition.routerLinkResolvers[platform];
          const resolverMapForPlatform = mappedResolvers[platform];
          const featureId = feature.resolveFeatureInfoFromStatic().context.featureId;
          this.addResolversToMap(resolversForPlatform, resolverMapForPlatform, featureId);
        });
      });
      return mappedResolvers;
    }));
    return convertToBehaviorSubject(null)(base);
  }
  generateResolversBaseMap() {
    const resolversBaseMap = {
      frontend: new Map(),
      admin: new Map()
    };
    return resolversBaseMap;
  }
  addResolversToMap(resolvers, targetPlatformResolverMap, featureId) {
    // eslint-disable-next-line guard-for-in
    for (const key in resolvers) {
      let resolverDef;
      if (typeof resolvers[key] === 'function') {
        resolverDef = {
          resolve: resolvers[key],
          featureId
        };
      } else {
        resolverDef = {
          ...resolvers[key],
          featureId
        };
      }
      targetPlatformResolverMap.set(key, resolverDef);
    }
  }
}